import { render, staticRenderFns } from "./EventVendors.vue?vue&type=template&id=4ace51b1&scoped=true"
import script from "./EventVendors.vue?vue&type=script&lang=js"
export * from "./EventVendors.vue?vue&type=script&lang=js"
import style0 from "./EventVendors.vue?vue&type=style&index=0&id=4ace51b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ace51b1",
  null
  
)

export default component.exports